{
  "access-denied-user": "L'utente inserito non può accedere a questo sito",
  "activation": "Attivazione",
  "code": "Codice",
  "code-sent": "Codice inviato",
  "contact": "Contatto",
  "enter": "Entra",
  "error-text": "Errore",
  "mail": "Email",
  "new-version-available": "Nuova versione disponibile",
  "password": "Password",
  "resend-wait": "Attendi {{seconds}}s per reinviare",
  "server-apologies": "Ci scusiamo per l'inconveniente",
  "server-maintenance": "Server in manutenzione",
  "translation-load-error": "Errore durante il caricamento delle traduzioni",
  "user": "Utente",
  "user-or-password-incorrect": "Nome utente o password errati",
  "wait": "Per favore, aspetta"
}